
<div class="spinner-h w-100 d-flex justify-content-center align-items-center" *ngIf='!ovoVegetarianRecipes'>
    <div class="spinner-grow text-success" role="status" *ngIf='!ovoVegetarianRecipes'>
        <span class="sr-only">Loading...</span>
    </div>    
</div>

<header class="mt-5 pt-5" *ngIf='ovoVegetarianRecipes'>

    <div class="container">
        <div class="row">
            <div class="recipes-header col-md-12 py-2 text-center rounded">
                <h1>Ovo-Vegetarian Recipes</h1>
            </div>
        </div>
    </div>
    
</header>

<section class="recipes text-center" *ngIf='ovoVegetarianRecipes'>
    <div class="container recipe-container rounded py-5 px-0">
        
        <div class="row row-cols-1 row-cols-md-3">

            <div class="col mb-4 p-3 " *ngFor="let recipe of ovoVegetarianRecipes">

              <a class="recipe-link" [routerLink]="['/recipeInfo', recipe.id]">
                <div class="card h-100 recipe-card">
                    <figure class="img-wrapper position-relative" >
                        <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                            <h2 class="text-white">View Details</h2>
                        </div>
                        <img [src]="recipe.image" [alt]='recipe.title' class="card-img-top" >
                    </figure>
                    <div class="card-body p-1 pt-2 ">
                      <h2 class="card-title ">{{recipe.title}}</h2>
                    </div>
                  </div>
              </a>

            </div>
            
        </div>

    </div>
</section>
